import { render, staticRenderFns } from "./DomainGroupNew.vue?vue&type=template&id=18751b4a&"
import script from "./DomainGroupNew.vue?vue&type=script&lang=js&"
export * from "./DomainGroupNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports